import { render, staticRenderFns } from "./OrdersMain.vue?vue&type=template&id=3452ed76&scoped=true"
import script from "./OrdersMain.vue?vue&type=script&lang=js"
export * from "./OrdersMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3452ed76",
  null
  
)

export default component.exports